var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pdf",
  transform: "translate(-14.769)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(14.769)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M64.544,14.377,51.01.313A1.022,1.022,0,0,0,50.274,0H30.1a4.1,4.1,0,0,0-4.094,4.093v14.3H17.832a3.066,3.066,0,0,0-3.063,3.062v15.33a3.066,3.066,0,0,0,3.063,3.062h8.175v9.2A4.094,4.094,0,0,0,30.1,53.126H60.736a4.093,4.093,0,0,0,4.094-4.083V15.085A1.022,1.022,0,0,0,64.544,14.377ZM50.527,2.758,61.637,14.3H50.527ZM17.832,37.8a1.02,1.02,0,0,1-1.02-1.019V21.452a1.021,1.021,0,0,1,1.02-1.019H45.42a1.021,1.021,0,0,1,1.02,1.019v15.33A1.021,1.021,0,0,1,45.42,37.8ZM62.787,49.043a2.048,2.048,0,0,1-2.051,2.04H30.1a2.049,2.049,0,0,1-2.051-2.042v-9.2H45.42a3.066,3.066,0,0,0,3.063-3.062V21.452A3.066,3.066,0,0,0,45.42,18.39H28.05V4.093A2.052,2.052,0,0,1,30.1,2.043H48.483V15.325a1.022,1.022,0,0,0,1.022,1.022H62.787v32.7Z",
  transform: "translate(-14.769 0)",
  fill: "#008c45"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(20.769 24.939)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M78.81,241.337a2.3,2.3,0,0,0-1.263-.859,10.313,10.313,0,0,0-2.107-.132H72.6v8.776h1.772v-3.31h1.155a10.112,10.112,0,0,0,1.838-.126,2.567,2.567,0,0,0,.919-.416,2.407,2.407,0,0,0,.745-.865,2.863,2.863,0,0,0,.293-1.359A2.725,2.725,0,0,0,78.81,241.337Zm-1.518,2.415a1.163,1.163,0,0,1-.554.431,4.582,4.582,0,0,1-1.4.138h-.97v-2.49h.856a8.512,8.512,0,0,1,1.275.06,1.225,1.225,0,0,1,.712.389,1.134,1.134,0,0,1,.281.79A1.179,1.179,0,0,1,77.292,243.752Z",
  transform: "translate(-72.596 -240.346)",
  fill: "#008c45"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(28.94 24.939)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M158.416,242.743a3.835,3.835,0,0,0-.838-1.422,2.935,2.935,0,0,0-1.323-.808,6.324,6.324,0,0,0-1.67-.168h-3.239v8.776h3.334a5.358,5.358,0,0,0,1.568-.186,3.113,3.113,0,0,0,1.245-.7,3.87,3.87,0,0,0,.94-1.55,5.768,5.768,0,0,0,.269-1.868A6.477,6.477,0,0,0,158.416,242.743Zm-1.724,3.6a1.857,1.857,0,0,1-.464.847,1.635,1.635,0,0,1-.715.365,4.824,4.824,0,0,1-1.072.084h-1.323v-5.813h.8a8.027,8.027,0,0,1,1.455.084,1.686,1.686,0,0,1,.82.413,2.008,2.008,0,0,1,.5.85,5.242,5.242,0,0,1,.18,1.562A5.724,5.724,0,0,1,156.692,246.347Z",
  transform: "translate(-151.346 -240.346)",
  fill: "#008c45"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(37.812 24.939)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M242.862,241.831v-1.485h-6.016v8.776h1.772v-3.729h3.664v-1.485h-3.664v-2.077Z",
  transform: "translate(-236.846 -240.346)",
  fill: "#008c45"
}))));
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.061,
    height: 53.126,
    viewBox: "0 0 50.061 53.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e512b0d2b6fb95a3bd2dc6e393a6c62e.svg";
export { ForwardRef as ReactComponent };